import api from "../config/api";

export const loginSuperAdmin = async (data) => {
  return await api.post("/superadmin/login", data);
};

export const updateSuperAdminProfile = async (id, data) => {
  return await api.put(`/superadmin/${id}/profile`, data);
};

export const changeSuperAdminPassword = async (id, data) => {
  return await api.post(`/superadmin/${id}/change-password`, data);
};
